import React from 'react'
import { Splide, SplideTrack, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import '@splidejs/react-splide/css/core';
const GasFeeSlider = () => {
    const slideItem = [1,2,3];
    return (
        <div className="_cross_slider_nft_wrapper">
            <div className="_cross_slider_nft_wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12">
                            <div className="_cross_slider_nft_head">
                                <h3 className="_cross_slider_nft_head_txt">Cross-blockchain resources</h3>
                                <p className="_cross_slider_nft_head_para">Learn more about
                                    the different blockchains to start creating
                                    and selling</p>
                            </div>
                            <div className="row">
                                <div className="col-xl-11 col-lg-11 col-md-12 mx-auto">
                                    <div className="_cross_slider_nft">
                                        <Splide
                                            hasTrack={false}
                                            options={{
                                                type: 'loop',
                                                perPage: 3,
                                                perMove: 1,
                                                focus: 'center',
                                                arrows: true,
                                                pagination: true,
                                                gap: 30,
                                                breakpoints: {
                                                    767: {
                                                        perPage: 2,
                                                    },
                                                    420: {
                                                        perPage: 1,
                                                    },
                                                }
                                            }}

                                        >
                                            <SplideTrack>
                                                {
                                                    slideItem.map((item,id)=>
                                                    <SplideSlide>
                                                        <div className="_cross_slider_nft_card">
                                                            <div className="_cross_slider_nft_card_img">
                                                                <img src={`assets/img/crss-slider-card-img0${item}.png`} alt="chobi" className="_cross_slider_nft_card_img_tag" />
                                                            </div>
                                                            <div className="_cross_slider_nft_card_txt">
                                                                <h6 className="_cross_slider_nft_card_txt1">how do i create and
                                                                    sell NFTs
                                                                    on polygon</h6>
                                                            </div>
                                                        </div>
                                                    </SplideSlide>
                                                    )
                                                }
                                            </SplideTrack>
                                            <div className="splide__arrows splide__arrows--ltr _cross_slider_nft_arrows">
                                                <button className="splide__arrow splide__arrow--prev" type="button" aria-controls="splide01-track" aria-label="Go to last slide">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={11} height={20} fill="none" viewBox="0 0 11 20">
                                                        <path stroke="#292D32" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M10.15 18.825 1.35 10l8.8-8.825" />
                                                    </svg>
                                                </button>
                                                <button className="splide__arrow splide__arrow--next" type="button" aria-controls="splide01-track" aria-label="Next slide">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={11} height={20} fill="none" viewBox="0 0 11 20">
                                                        <path stroke="#292D32" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M.85 18.825 9.65 10 .85 1.175" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </Splide>
                                    </div>
                                </div>
                            </div>
                            <div className="_cross_slider_nft_link">
                                <a href="#0" className="_cross_slider_nft_link1">
                                    Learn More on our help center
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GasFeeSlider